module.exports = __webpack_public_path__ + "static/media/parasailing1.559341ae.jpg";